import styled from 'styled-components'

export const NotFoundPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #f0f2f5;
`